/*    
<summary>
  This functional component "Device Status Filter" renders the filter form.
  Developer:Aashish Singh, Created Date: 04-July-2025
</summary>
<returns>Returns JSX</returns>
*/

import { Field, Form, Formik } from "formik";
import { observer } from "mobx-react";
import moment from "moment";
import React from "react";
import { Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { DATE_FORMAT, fotaHostScheduleSearchByOptions } from "../../../constants/common-constants";
import LoaderButton from "../../../shared-components/Button/LoaderButton";
import FormikDateFieldMUI from "../../../shared-components/FormikFormHandlers/FormikDateFieldMUI";
import FormikFormSelect from "../../../shared-components/FormikFormHandlers/FormikFormSelect";
import { fotaHostFilterValidationSchema } from "../../../shared-components/FormikFormHandlers/FormikValidationSchema";
import Label from "../../../shared-components/Label/Label";
import { formatMessage } from "../../../translations/format-message";
import FormikFormInputFilter from "../../../shared-components/FormikFormHandlers/FormikFormInputFilter";
import FormikFormInput from "../../../shared-components/FormikFormHandlers/FormikFormInput";

interface IProps {
  initialValues: any;
  submitHandler: (values: any) => void;
  isFilterActive: boolean;
  modalClosed: () => void;
}

const FotaHostViewFilterForm = (props: IProps) => {
  return (
    <Modal
      className="fancy-modal"
      show={true}
      centered={false}
      size="lg"
      onHide={() => { }}
    >
      <Modal.Header>
        <Modal.Title>
          <FormattedMessage id="filter" />
        </Modal.Title>
        <button
          onClick={props.modalClosed}
          data-testid="Close"
          className="Crossicons"
          title={formatMessage("close")}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            className="bi bi-x"
            viewBox="0 0 16 16"
          >
            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
          </svg>
        </button>
      </Modal.Header>
      <div className="p-0">
        <Formik
          initialValues={props.initialValues}
          enableReinitialize
          validateOnBlur={false}
          validationSchema={fotaHostFilterValidationSchema}
          onSubmit={async (values: any) => {
            let startDate =
              new Date(values.ScheduleStartDate?.$d).toString() !==
                "Invalid Date"
                ? moment(values.ScheduleStartDate.$d).format(DATE_FORMAT)
                : values.ScheduleStartDate;
            let endDate =
              new Date(values.ScheduleEndDate?.$d).toString() !==
                "Invalid Date"
                ? moment(values.ScheduleEndDate.$d).format(DATE_FORMAT)
                : values.ScheduleEndDate;

            let tempSearchBy = typeof values.SearchBy === "string" ? parseInt(values.SearchBy) : 0;
            let tempValues: any = {
              SearchBy: tempSearchBy,
              ScheduleStartDate: tempSearchBy == 1 ? startDate : "",
              ScheduleEndDate: tempSearchBy == 1 ? endDate : "",
              ConfigName: tempSearchBy == 2 ? values.ConfigName : "",
              VersionNo: tempSearchBy == 3 ? values.VersionNo : "",
            };
            props.submitHandler({ ...tempValues });
          }}
        >
          {({ values }) => {
            return (
              <Form className="user-form p-3">
                <div className="form-group row">
                  <Label
                    className="label-style col-sm-5 col-form-label"
                    required={true}
                    label="search_by"
                  />
                  <div className="col-sm-7">
                    <Field
                      name="SearchBy"
                      as={FormikFormSelect}
                      options={fotaHostScheduleSearchByOptions}
                    />
                  </div>
                </div>
                <div className="">
                  {
                    values.SearchBy == 1 &&
                    <>
                      <div className="form-group row">
                        <Label
                          className="col-sm-5 label-style"
                          required={true}
                          label="start_date"
                        />
                        <div className="col-sm-7">
                          <Field name="ScheduleStartDate"
                            as={FormikDateFieldMUI}
                            disableFuture={false}
                          // min={moment().subtract(3, 'months').format(DATE_FORMAT)}
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <Label
                          className="col-sm-5 label-style"
                          required={true}
                          label="end_date"
                        />
                        <div className="col-sm-7">
                          <Field name="ScheduleEndDate"
                            as={FormikDateFieldMUI}
                            disableFuture={false}
                          // min={moment().subtract(3, 'months').format(DATE_FORMAT)}
                          />
                        </div>
                      </div>
                    </>
                  }
                  {
                    values.SearchBy == 2 &&
                    <>
                      <div className="form-group row">
                        <Label
                          className="col-sm-5 label-style"
                          required={true}
                          label="fota_config_name"
                        />
                        <div className="col-sm-7">
                          <Field className="form-control"
                            name="ConfigName" as={FormikFormInputFilter} type="text"
                            validcharacter={["@", "#", "$", "-", "_", "."]}
                            placeholder="fota_config_name"
                          />
                        </div>
                      </div>

                    </>
                  }
                  {
                    values.SearchBy == 3 &&
                    <>
                      <div className="form-group row">
                        <Label
                          className="col-sm-5 label-style"
                          required={true}
                          label="version"
                        />
                        <div className="col-sm-7">
                          <Field className="form-control" name="VersionNo" invalidcharacter={[" "]}
                            validcharacter={[".", "-", "_"]}
                            type="text" placeholder="version" as={FormikFormInput}
                          />
                        </div>
                      </div>

                    </>
                  }
                </div>

                <div className="d-flex justify-content-end pb-2">
                  <button
                    data-testid="apply"
                    className="btn btn-secondary"
                    type="button"
                    onClick={props.modalClosed}
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <FormattedMessage id="button_cancel" />
                  </button>

                  <LoaderButton type="submit" className="ms-2" text="apply" />
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </Modal>
  );
};

export default observer(FotaHostViewFilterForm);
